<div class="mt-2 sm:px-0">
  <soft-tab-group class="mt-2 sm:mt-3">
    <soft-tab [title]="'Neue Palette'">
      <div
        class="flex flex-col px-3 sm:px-0 justify-start min-h-[40vh] max-h-[65vh] overflow-y-auto"
      >
        <div class="flex flex-col w-full mt-2 py-2 border-b border-solid">
          <div class="flex flex-col">
            <p class="font-semibold">
              {{ bewe().lfdnr | number: '3.0' }}
            </p>
            <p class="text-sm">
              {{
                '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_LIEFERANT_ARTIKELNUMMER' | translate
              }}
              {{ bewe().artikelMenge.artikel.lieferantArtikelNummer ?? '' }} |
              {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_EAN' | translate }}
              {{ bewe().artikelMenge.artikel.ean }} |
              {{ '#WWS_WARENUEBERNAHME.BEWEGUNG.LABEL_ARTIKELNUMMER' | translate }}
              {{ bewe().artikelMenge.artikel.nummer ?? '' }}
            </p>
            <p class="font-semibold text-base">
              {{ bewe().artikelMenge.artikel.artbez1 ?? 'Artikel' }}
            </p>
            <p
              class="text-light"
              *ngIf="
                bewe().artikelMenge.artikel.artbez2 &&
                bewe().artikelMenge.artikel.artbez2 !== ''
              "
            >
              {{ bewe().artikelMenge.artikel.artbez2 }}
            </p>
          </div>
        </div>

        <div class="mt-4">
          <div class="font-bold text-sm text-primary-400 mb-1">
            {{ '#WWS_WARENUEBERNAHME.DIALOG.TITEL_ANZAHL_ETIKETTEN' | translate }}
          </div>
          <soft-mengen-eingabe
            #mengenEingabe
            [einheit]="
              ('#WWS_WARENUEBERNAHME.DIALOG.ETIKETTEN_LABEL' | translate) ?? undefined
            "
            [preventKeyboardEventEmission]="true"
            [minValue]="bewe()?.anzahlPalettenMin ?? null"
            [value]="anzahlEtiketten()"
            (valueChange)="anzahlEtiketten.set($event)"
          >
          </soft-mengen-eingabe>

          @if (anzahlEtiketten() > 1) {
            <div class="flex flex-col w-full mt-2 mb-2">
              @for (row of rowsForSplitting(); track $index) {
                <div
                  class="flex items-center justify-between py-2 w-full"
                  [class.border-b]="!$last"
                >
                  <div class="flex flex-col gap-0.5 w-full">
                    <span class="text-base font-semibold w-full"
                      >Palette {{ $index + 1 | number: '2.0-0' }}</span
                    >
                    <span class="text-sm text-light">Menge für diese Palette</span>
                  </div>

                  <soft-mengen-eingabe
                    class="w-full"
                    size="small"
                    [einheit]="bewe().artikelMenge.einheit.arteh"
                    [value]="row.amount"
                    [float]="true"
                    (valueChange)="changePalletAmount(row.index, $event)"
                    [preventKeyboardEventEmission]="true"
                  ></soft-mengen-eingabe>
                </div>
              }
            </div>
          }
        </div>
      </div>

      <div class="mt-2 flex flex-col w-full gap-1">
        @let differenz = splittingSum() - (bewe()?.artikelMenge?.menge ?? 0);

        @if (differenz !== 0 && anzahlEtiketten() > 1) {
          <div
            class="flex items-center w-auto gap-3 py-1.5 px-2.5 rounded border border-danger-600 bg-danger-50"
          >
            <soft-icon
              name="fa-solid fa-triangle-exclamation text-danger-600 text-xl"
            ></soft-icon>
            <div class="flex flex-col">
              <span class="text-danger-600 text-sm font-semibold"
                >Differenzmenge: {{ differenz | number: '1.0-9' }}
                {{ bewe().artikelMenge.einheit.arteh }}</span
              >
              <span class="text-xs text-light"
                >Die Gesamtmenge muss {{ bewe().artikelMenge.menge | number: '1.0-9' }}
                {{ bewe().artikelMenge.einheit.arteh }} ergeben! Aktuelle Gesamtmenge:
                {{ splittingSum() | number: '1.0-9' }}
                {{ bewe().artikelMenge.einheit.arteh }}</span
              >
            </div>
          </div>
        }

        <button
          class="soft-button primary mt-2 rounded-sm h-16 w-full"
          [disabled]="
            (bewe()?.anzahlPalettenMin !== undefined &&
              bewe()?.anzahlPalettenMin !== null &&
              mengenEingabe.value < (bewe()?.anzahlPalettenMin ?? 0)) ||
            mengenEingabe.value < 0 ||
            (anzahlEtiketten() > 0 && splittingSum() !== bewe()?.artikelMenge?.menge)
          "
          (click)="positionErledigen(mengenEingabe.value)"
        >
          {{
            '#WWS_WARENUEBERNAHME.DIALOG.TITEL_POSITION_ERLEDIGT_MARKIEREN' | translate
          }}
        </button>
      </div>
    </soft-tab>
    <soft-tab [title]="'Bestehende Palette'">
      <div class="flex flex-col mt-2 min-h-[40vh] max-h-[65vh]">
        <div class="flex flex-col divide-y">
          @let paletten = selectableMischPaletten();
          @if (paletten && paletten.length > 0) {
            @for (palette of paletten; track $index) {
              <div
                class="flex flex-col gap-1 justify-center px-2 py-2"
                [ngClass]="
                  selectedMischPalette()?.palette?.sscc === palette.palette.sscc
                    ? 'bg-selected'
                    : 'bg-surface hover:bg-hover'
                "
                (click)="selectedMischPalette.set(palette)"
              >
                <span class="text-sm font-light">{{ palette.palette.id }}</span>
                <span>{{ palette.palette.sscc }}</span>
                <span class="text-sm font-extralight">{{
                  palette?.lagerplatz?.lagerplatz
                }}</span>
              </div>
            }
          } @else {
            <div class="flex justify-center mt-2">
              <span class="font-light italic text-sm"
                >Es wurden keine Mischpaletten gefunden.</span
              >
            </div>
          }
        </div>
      </div>

      <button
        class="soft-button primary mt-2 rounded-sm h-16 w-full"
        [disabled]="selectedMischPalette() === null"
        (click)="positionErledigenMischPaeltte()"
      >
        {{ '#WWS_WARENUEBERNAHME.DIALOG.TITEL_POSITION_ERLEDIGT_MARKIEREN' | translate }}
      </button>
    </soft-tab>
  </soft-tab-group>
</div>
